import { CORNER_TYPES } from '@app/constants';
import { roundNum } from '@app/utils/utils';
import CornerRoundedIcon from '@images/icons/icon-corner-rounded.svg';
import CornerScallopedIcon from '@images/icons/icon-corner-scalloped.svg';
import CornerSquaredIcon from '@images/icons/icon-corner-squared.svg';
import EdgeScallopedIcon from '@images/icons/icon-edge-scalloped.svg';
import EdgeSmoothIcon from '@images/icons/icon-edge-smooth.svg';

const adjustSizesForShape = (initialWidth, initialHeight, maxValue) => {
  let adjustedWidth = initialWidth === initialHeight ? roundNum(initialWidth * 1.2, 1) : initialWidth;
  let adjustedHeight = initialHeight;

  if (adjustedWidth > maxValue) {
    adjustedWidth = maxValue;
    adjustedHeight = roundNum(maxValue / 1.2, 1);
  }

  return { adjustedWidth, adjustedHeight };
};

export const SIZE_ADJUST_CONFIG = {
  square: {
    pair: 'rect',
    adjust: (initialWidth, initialHeight) => ({
      adjustedWidth: Math.min(initialWidth, initialHeight),
      adjustedHeight: Math.min(initialWidth, initialHeight),
    }),
  },
  rect: {
    pair: 'square',
    adjust: adjustSizesForShape,
  },
  circle: {
    pair: 'ellipse',
    adjust: (initialWidth, initialHeight) => ({
      adjustedWidth: Math.min(initialWidth, initialHeight),
      adjustedHeight: Math.min(initialWidth, initialHeight),
    }),
  },
  ellipse: {
    pair: 'circle',
    adjust: adjustSizesForShape,
  },
};

export const CORNER_TYPES_CONFIG = {
  [CORNER_TYPES.ROUNDED_CORNER]: {
    icon: CornerRoundedIcon,
    conditions: ['rect', 'square', 'scallop_rect', 'scallop_square'],
    defaultForShapes: ['rect'],
  },
  [CORNER_TYPES.SQUARED_CORNER]: {
    icon: CornerSquaredIcon,
    conditions: ['rect', 'square', 'scallop_rect', 'scallop_square'],
    defaultForShapes: ['square'],
  },
  [CORNER_TYPES.SCALLOPED_CORNER]: {
    icon: CornerScallopedIcon,
    conditions: ['rect', 'square', 'scallop_rect', 'scallop_square'],
    defaultForShapes: ['scallop_rect', 'scallop_square'],
  },
  [CORNER_TYPES.SMOOTH_EDGE]: {
    icon: EdgeSmoothIcon,
    conditions: ['circle', 'ellipse', 'scallop_circle', 'scallop_ellipse'],
    defaultForShapes: ['circle', 'ellipse'],
  },
  [CORNER_TYPES.SCALLOPED_EDGE]: {
    icon: EdgeScallopedIcon,
    conditions: ['circle', 'ellipse', 'scallop_circle', 'scallop_ellipse'],
    defaultForShapes: ['scallop_circle', 'scallop_ellipse'],
  },
};

export const SCALLOPED_CORNER_MAPPING = {
  [CORNER_TYPES.SCALLOPED_EDGE]: CORNER_TYPES.SCALLOPED_CORNER,
  [CORNER_TYPES.SCALLOPED_CORNER]: CORNER_TYPES.SCALLOPED_EDGE,
};
